import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@/components/Dialog';
import { FormGroup } from '@tencent/spaui';
import PotentialStatusSelect from '@/components/PotentialStatusSelect';
import PotentialReasonSelect from '@/business-components/sale/PotentialReasonSelect';
import { POTENTIAL_SECOND_SEASON, PROGRESS_STATUS } from '@/constants/Constants';
import message from '@/utils/message';

class ChangePotentialStatusModal extends React.Component {
  static propTypes = {
    webApi: PropTypes.object.isRequired,
    lead: PropTypes.object.isRequired,
    potential: PropTypes.object,
    actionRecord: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    if (props.potential) {
      const { potentialStatus, transactionProbability, potentialSecondSeasonType } = props.potential;
      this.state = { potentialStatus, transactionProbability, potentialSecondSeasonType };
    } else {
      this.state = {};
    }
    this.state.description = props.actionRecord.description;
  }

  render() {
    const { lead, potential } = this.props;
    const { potentialStatus, transactionProbability, description, submitting, potentialSecondSeasonType } = this.state;
    return (
      <Dialog className="CreateActionRecordModal" title="修改商机状态" subTitle={lead.company.companyName} {...this.props} style={{ width: 640 }} onSubmit={this.handleSubmit} disabled={submitting}>
        <FormGroup className={'with-select'}>
          <label htmlFor={'potentialStatus'}>商机状态：</label>
          <PotentialStatusSelect id={'potentialStatus'} mode={'block'} potentialStatus={potentialStatus} transactionProbability={transactionProbability} disableCreateOrder={true} onChange={this.handleChangePotentialStatus} />
        </FormGroup>
        {
          potentialStatus && <FormGroup className={'with-select required'}>
            <label htmlFor={'potentialStatus'}>意向原因：</label>
            <PotentialReasonSelect
              potentialStatus={`${potentialStatus}-${transactionProbability}`}
              value={potentialSecondSeasonType !== POTENTIAL_SECOND_SEASON.POTENTIAL_SECOND_SEASON_UNKNOWN ? potentialSecondSeasonType : undefined}
              onChange={this.handlePotentialSecondSeasonType}
            />
          </FormGroup>
        }
        <FormGroup className={'required with-textarea'}>
          <label htmlFor={'description'}>跟进情况：</label>
          <textarea id={'description'} className="spaui-input" minLength={3} value={description || ''} onChange={this.handleChangeDescription} />
        </FormGroup>
      </Dialog>
    );
  }

  handleChangePotentialStatus = (e, value) => {
    const { potentialStatus, transactionProbability } = value;
    this.setState({
      potentialStatus,
      transactionProbability,
      error: undefined,
      potentialSecondSeasonType: undefined,
    });
  }

  handlePotentialSecondSeasonType = (e, potentialSecondSeasonType) => {
    this.setState({ potentialSecondSeasonType });
  }

  handleChangeDescription = (e) => {
    this.setState({
      description: e.target.value,
      error: undefined,
    });
  }

  handleSubmit = () => {
    const { potentialStatus, transactionProbability, description, potentialSecondSeasonType } = this.state;
    const {
      webApi,
      lead: { leadId, progressStatus },
      potential,
      actionRecord,
      onSubmit,
    } = this.props;

    // 数据校验
    if (potential) {
      if (potentialStatus === 'POTENTIAL_STATUS_NEW') {
        return;
      }
      // 商机阶段商机状态，商机原因必填校验
      if (progressStatus === PROGRESS_STATUS.PROGRESS_STATUS_POTENTIAL && (!potentialStatus || !potentialSecondSeasonType || potentialSecondSeasonType === POTENTIAL_SECOND_SEASON.POTENTIAL_SECOND_SEASON_UNKNOWN)) {
        return;
      }
      if (potential.transactionProbability !== transactionProbability) {
        if (transactionProbability === 100) {
          return;
        }
      }
    }
    if (!description) {
      return;
    }

    // 提交
    this.setState({
      submitting: true,
      error: undefined,
    });
    webApi
      .updateActionRecord(leadId, actionRecord.recordId)
      .ajaxJson({
        data: {
          potentialStatus,
          transactionProbability,
          description,
          potentialSecondSeasonType,
        },
      })
      .then(
        (resp) => {
          this.setState({
            submitting: false,
          });
          onSubmit(resp);
        },
        (error) => {
          message.error(error?.json.message || error?.message);
          this.setState({
            submitting: false,
            error,
          });
        },
      );
  }
}

export default ChangePotentialStatusModal;
